import * as React from 'react';
import {useFormikContext} from 'formik';
import {CourseObject} from 'api/course';
import Row from 'components/Row';
import Column from 'components/Column';
import FormContainer from '../../containers/FormContainer';
import {DatePicker} from "components/DatePicker";
import {DatePickerDateArg} from "components/DatePicker/DatePicker";

/**
 * The fixed date form part of settings
 * @return {React.ReactElement}
 * @constructor
 */
export default function FixedDateForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<CourseObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render fixed date field
     * @return {JSX.Element}
     */
    function renderFixedDate(): JSX.Element {
      /**
       * Render start date
       * @return {JSX.Element}
       */
      function renderStartDate(): JSX.Element {
        /**
         * Handle date change
         * @param {DatePickerDateArg} date
         */
        function handleChange(date: DatePickerDateArg): void {
          formContext.setFieldValue('fixedDate.dates.startDate', date);
          formContext.submitForm();
        }

        return (
          <Column>
            <Row>
              <Column>
                <DatePicker
                  id="fixedDate.dates.startDate"
                  label="Дата старта"
                  dateFormat="dd.MM.yyyy в HH:mm"
                  selected={formContext.values.fixedDate?.dates?.startDate}
                  showTimeSelect
                  onChange={handleChange}
                  required
                />
              </Column>
            </Row>
          </Column>
        );
      }

      /**
       * Render over date
       * @return {JSX.Element}
       */
      function renderOverDate(): JSX.Element {
        /**
         * Handle date change
         * @param {DatePickerDateArg} date
         */
        function handleChange(date: DatePickerDateArg) {
          formContext.setFieldValue('fixedDate.dates.overDate', date);
          formContext.submitForm();
        }

        return (
          <Column>
            <Row>
              <Column>
                <DatePicker
                  id="fixedDate.dates.overDate"
                  label="Дата окончания"
                  dateFormat="dd.MM.yyyy в HH:mm"
                  selected={formContext.values.fixedDate?.dates?.overDate}
                  showTimeSelect
                  onChange={handleChange}
                />
              </Column>
            </Row>
          </Column>
        );
      }

      return (
        <Row>
          {renderStartDate()}
          {renderOverDate()}
        </Row>
      );
    }

    return (
      <React.Fragment>
        {renderFixedDate()}
      </React.Fragment>
    );
  }

  return (
    <FormContainer
      property="fixedDate"
      label="Привязать курс к конкретной дате"
      collapse
    >
      {renderContent()}
    </FormContainer>
  );
}
